import { red } from "@mui/material/colors";

const styles = {
  primaryContainer: {
    padding: 0,
  },
  mainContainer: {
    backgroundColor: "white",
    borderRadius: "1rem",
    width: "100%",
    padding: "20px",
    marginBottom: "12px",
    gap: "10px",
  },
  searchField: {
    height: "38px",
    borderRadius: "0.5rem",
    flexGrow: 1,
  },
  assingLot: {
    width: "180px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
  },
  tabContainer: {
    borderBottom: 1,
    borderColor: "divider",
    width: "100%",
  },
  tabPanel: {
    width: "100%",
    padding: "16px 0",
  },
};

export default styles;
